import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CreateProjectData,
	Project,
	ProjectsAndPhasesResponse,
	ProjectSummary,
	UpdateProjectData,
} from "~/modules/project/api/project/projectTypes.ts";
import type { ProjectTagTypeId } from "~/modules/project/api/projectTag/projectTagTypes.ts";


export function getProject(projectId: string): AxiosApiResponsePromise<Project> {
	return axiosApi.get(`projects/${projectId}`);
}

export function getAllProjects(): AxiosApiResponsePromise<ProjectSummary[]> {
	return axiosApi.get("projects");
}

export function getAllProjectsAndPhases(): AxiosApiResponsePromise<ProjectsAndPhasesResponse> {
	return axiosApi.get("projects-and-phases");
}

export function getClientsProjects({ clientId }: { clientId: string }): AxiosApiResponsePromise<Project[]> {
	return axiosApi.get(`clients/${clientId}/projects`);
}

export function createProject(projectData: CreateProjectData): AxiosApiResponsePromise<Project> {
	return axiosApi.post("projects", { ...projectData });
}

export function updateProject({ projectId, projectData }: {
	projectId: string,
	projectData: UpdateProjectData
}): AxiosApiResponsePromise<Project> {
	return axiosApi.put(`projects/${projectId}`, { ...projectData });
}

export function deleteProject({ projectId }: {
	projectId: string
}): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`projects/${projectId}`);
}

export function updateProjectsCuratedTags({ projectId, tagIds, tagTypeId }: {
	projectId: string,
	tagIds: string[],
	tagTypeId: ProjectTagTypeId
}): AxiosApiResponsePromise<Project> {
	return axiosApi.patch(`projects/${projectId}/curated-tags`, { tagIds, tagTypeId });
}

export function updateProjectsUserTags({ projectId, tagDisplayNames, tagTypeId }: {
	projectId: string,
	tagDisplayNames: string[],
	tagTypeId: ProjectTagTypeId
}): AxiosApiResponsePromise<Project> {
	return axiosApi.patch(`projects/${projectId}/user-tags`, { tags: tagDisplayNames, tagTypeId });
}
